<template>
  <div id="settings-engineers-users-hkland-data">
    <table class="setting-table user-table">
      <thead>
        <th class="user-name">{{ $t(defaultHeader.name) }}</th>
        <th class="user-status">{{ $t(status.name) }}</th>
        <th class="last-login">{{ $t(lastLogin.name) }}</th>
      </thead>
      <tbody class="setting-tbody">
        <tr>
          <td class="user-name">
            <input
              type="text"
              id="settings-engineers-users-hkland-user-filter"
              class="setting-users-filter-search"
              v-model="defaultHeader.filter"
            >
          </td>
          <td class="user-status settings-filter">
            <HKLSelect
              :value="status.filter"
              class="hkld-user-status-filter"
              settings-filter-row
              :options="statusHklOptions"
              :showSearch="false"
              placeholder=""
              @change="val => { status.filter = val }"
            />
          </td>
          <td
            class="last-login"
            id="settings-engineers-users-hkland-user-last-login"
          />
        </tr>
        <table class="list">
          <tbody>
            <template v-for="(user, index) in filteredUsers">
              <tr
                v-if="user.id !== systemUserId"
                :key="user.id"
              >
                <td class="user-name">
                  <a :id="'settings-engineers-users-hkland-user-' + index">{{ userName(user) }}</a>
                </td>
                <td class="user-status">
                  <div>{{ user.enabled ? $t('status.active') : $t('status.inactive') }}</div>
                </td>
                <td class="last-login">
                  <div>{{ formatDate(user.lastLoginAt) }}</div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </tbody>
    </table>
  </div>
</template>
<script>
import lodash from 'lodash'
import { getUsersByDepartmentId } from '@/api/departments/request'
import { systemUserId } from '@/utils/consts'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import dateUtil from '@/utils/dateUtil'
import userHelper from '@/utils/userHelper'
import { ROUTER_PATHS } from '@/constants/router'

export default {
  name: 'Users',
  components: {
    HKLSelect,
  },
  model: {
    prop: 'extData',
    event: 'onChange',
  },
  props: ['extData', 'formOptions'],
  data () {
    const statusOptions = [
      {
        value: 'all',
      },
      {
        value: 'active',
      },
      {
        value: 'inactive',
      },
    ]
    const defaultHeader = {
      name: 'settings.departmentUser',
      filter: '',
    }
    const status = {
      name: 'status.name',
      filter: statusOptions[0].value,
    }
    const lastLogin = {
      name: 'lastLogin',
      filter: '',
    }

    return {
      defaultHeader,
      users: [],
      statusOptions,
      status,
      lastLogin,
      systemUserId: systemUserId, // filter system user
    }
  },
  computed: {
    filteredUsers () {
      return lodash.orderBy(lodash.filter(this.users, item => {
        const isContainUsername = item.username.toString().split('@')[0].toLowerCase().indexOf(this.defaultHeader.filter.toLowerCase()) !== -1
        const isContainDisplayName = (item.displayName || ' ').toString().toLowerCase().indexOf(this.defaultHeader.filter.toLowerCase()) !== -1
        if (isContainUsername || isContainDisplayName) {
          return item
        }
      }).filter((item) => {
        const filter = this.status.filter
        const currentStatus = item.enabled ? 'active' : 'inactive'
        if (filter !== this.statusOptions[0].value) {
          return currentStatus === filter
        } else {
          return true
        }
      }), 'displayName')
    },
    statusHklOptions () {
      return this.statusOptions.map((option) => ({
        name: this.$options.filters.customStatusLabel(option.value),
        value: option.value,
      }))
    },
  },
  methods: {
    navToUserDetail (id) {
      this.$router.push({
        name: ROUTER_PATHS.HKL_USER_DETAIL,
        params: { id },
      })
    },
    userName (user) {
      const name = userHelper.getUserName(user.username, user.displayName)
      return name
    },

    formatDate (dateString) {
      return dateUtil.formatDate(dateString, true)
    },
  },
  watch: {
    async '$route.params.id' (newId, oldId) {
      if (newId !== oldId) {
        this.users = await getUsersByDepartmentId(newId)
      }
    },
  },
  async mounted () {
    this.users = await getUsersByDepartmentId(this.extData.id)
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/settings/style';
.setting-table.user-table {
  border-spacing: 0px;
  thead {
    th:last-child {
      flex: 0 1 auto;
      flex-direction: row;
      margin-left: 52px;
    }
    .user-status {
      width: 150px;
    }
  }
  .setting-tbody {
    overflow: visible;
    height: auto;
    .user-name, .last-login {
      min-width: 200px;
      max-width: 200px;
    }
    .user-name a {
      cursor: auto;
    }
    .user-status {
      min-width: 150px;
      max-width: 150px;
    }
    .list {
      background: white;
      tbody {
        height: 600px;
        overflow: auto;
        tr:nth-child(odd) {
          background: #fff;
        }
        tr:nth-child(even) {
          background: #f1f1f1;
        }
      }
    }
  }
}

th:not(:first-child), td:not(:first-child) {
  text-align: center;
}
td {
  padding-top: 2px;
  padding-bottom: 2px;
}
td input[type="text"] {
  width: 150px;
  min-width: 150px;
}

#settings-engineers-users-hkland-user-filter {
  width: 115px;
}

</style>
